import { Stack, type StackProps } from 'tamagui'

export default function CobuView(props: StackProps) {
  return <Stack {...props} />
}


